import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { ErrorService } from '@app/core/services/error/error.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private _errorService: ErrorService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((response: any) => {
        if (
          response instanceof HttpErrorResponse &&
          response.error.message === 'INVALID_REQUEST'
        ) {
          this._errorService.routeToErrorPage();
        }
        return throwError(response);
      }),
    );
  }
}
